export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const normalizeFeeFrequency = (optionOrName) =>
  String(
    optionOrName?.feeFrequencyName ||
      optionOrName?.frequencyName ||
      optionOrName?.label ||
      optionOrName ||
      "",
  )
    .toLowerCase()
    .replace(/\s+/g, "")
    .trim();

export const getFeePeriodCount = (optionOrName) => {
  const frequency = normalizeFeeFrequency(optionOrName);

  if (frequency === "monthly" || frequency === "montly") return 12;
  if (
    frequency === "quarterly" ||
    frequency === "quaterly" ||
    frequency === "quartely"
  ) {
    return 4;
  }
  if (
    frequency === "halfyearly" ||
    frequency === "halfyear" ||
    frequency === "halfyrly"
  ) {
    return 2;
  }
  if (frequency === "yearly" || frequency === "annual" || frequency === "annually") {
    return 1;
  }

  return 0;
};

export const isMonthlyFeeFrequency = (optionOrName) =>
  getFeePeriodCount(optionOrName) === 12;

export const isYearlyFeeFrequency = (optionOrName) => {
  const frequency = normalizeFeeFrequency(optionOrName);
  return frequency === "yearly" || frequency === "annual" || frequency === "annually";
};

export const getFeePeriodLabel = (periodOption, frequency, index = 0) => {
  if (!periodOption) return "";

  const label = periodOption.label || periodOption.period_name || periodOption;
  return isYearlyFeeFrequency(frequency) && index === 0
    ? `${label} (Yearly)`
    : label;
};
